// removed by extract-text-webpack-plugin
module.exports = {"termsAndPrivacy":"TermsAndPrivacy__termsAndPrivacy","message":"TermsAndPrivacy__message","terms":"TermsAndPrivacy__terms","privacy":"TermsAndPrivacy__privacy","growDotQello":"TermsAndPrivacy__growDotQello","growDotBlue":"TermsAndPrivacy__growDotBlue","growDotGolden":"TermsAndPrivacy__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsAndPrivacy/TermsAndPrivacy.scss
// module id = 1885
// module chunks = 0